module.exports = __webpack_public_path__ + "static/media/golf-outing-home.70b50db9.jpg";